import { OptionModel } from '@Entities/lib'
import { Maybe } from '@Types'

export const getCountryTitle = (countryOptions: OptionModel[], country: Maybe<number>) => {
    const countryObj = countryOptions && country && countryOptions.find((option) => +option.id === country)
    return countryObj ? countryObj.label : ''
}
